module.exports = require('./src/Scripts/jquery.fileDownload');



//////////////////
// WEBPACK FOOTER
// ./bower_components/jquery-file-download/index.js
// module id = 65
// module chunks = 0